/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_Code_LabelInputs */

const en_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-digit verification code`)
};

const de_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-stelliger Bestätigungscode`)
};

const fr_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de vérification à 6 chiffres`)
};

const es_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificación de 6 dígitos`)
};

const it_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di verifica a 6 cifre`)
};

const nl_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-cijferige verificatiecode`)
};

const pl_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-cyfrowy kod weryfikacyjny`)
};

const fi_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-numeroinen vahvistuskoodi`)
};

const da_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-cifret bekræftelseskode`)
};

const sv_onboarding_verify_code_label = /** @type {(inputs: Onboarding_Verify_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-siffrig verifieringskod`)
};

/**
* | output |
* | --- |
* | "6-digit verification code" |
*
* @param {Onboarding_Verify_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_code_label = /** @type {((inputs?: Onboarding_Verify_Code_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Code_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_code_label(inputs)
	if (locale === "fr") return fr_onboarding_verify_code_label(inputs)
	if (locale === "es") return es_onboarding_verify_code_label(inputs)
	if (locale === "it") return it_onboarding_verify_code_label(inputs)
	if (locale === "nl") return nl_onboarding_verify_code_label(inputs)
	if (locale === "pl") return pl_onboarding_verify_code_label(inputs)
	if (locale === "fi") return fi_onboarding_verify_code_label(inputs)
	if (locale === "da") return da_onboarding_verify_code_label(inputs)
	if (locale === "sv") return sv_onboarding_verify_code_label(inputs)
	return en_onboarding_verify_code_label(inputs)
});